// umlaut-check: skip — "verfuegbarkeiten" ist ein Prop-/Variablenname, der
// den JSON-Schluessel der Antwort spiegelt (technischer Bezeichner).

import React from "react";
import {Card, Table} from "react-bootstrap";
import HeaderWithHelp from "../SalesAnalysis/HeaderWithHelp.jsx";
import {formatCosmosWoche, formatDatum, formatMenge, produktionsstatusLabel} from "./format.js";

/**
 * Jüngster Produktionsstand, Cosmos-Lagerverfügbarkeit je Woche und
 * stehengebliebene B2B-Warenkörbe (PLAN.md Abschnitt 5, F17) - drei kleine,
 * unabhängig verschwindende Bausteine, weil keiner davon in jedem
 * Datenstand gefüllt ist.
 */
export default function ArtikelProduktionUndVerfuegbarkeit({produktionsstaende, verfuegbarkeiten, warenkoerbe}) {
    const hatProduktion = produktionsstaende && produktionsstaende.length > 0;
    const hatVerfuegbarkeit = verfuegbarkeiten && verfuegbarkeiten.length > 0;
    const hatWarenkorb = warenkoerbe && warenkoerbe.anzahl > 0;

    if (!hatProduktion && !hatVerfuegbarkeit && !hatWarenkorb) {
        return null;
    }

    return (
        <div className="d-flex flex-wrap gap-3">
            {hatProduktion && (
                <Card className="shadow-sm flex-fill" style={{minWidth: 280}}>
                    <Card.Header className="fw-semibold small">
                        <HeaderWithHelp help="Aus dem Block PRODUCTION der Ampel-Datei – Standmenge, Status und offene Restmenge je Erfassungsstand.">
                            Produktionsstand
                        </HeaderWithHelp>
                    </Card.Header>
                    <Card.Body className="p-2">
                        <Table size="sm" borderless className="mb-0">
                            <tbody>
                                {produktionsstaende.slice(0, 5).map((p, i) => (
                                    <tr key={i}>
                                        <td className="small text-muted">{formatDatum(p.stand_am)}</td>
                                        <td className="small">{produktionsstatusLabel(p.status, p.status_text)}</td>
                                        <td className="text-end">{formatMenge(p.menge_gesamt)}</td>
                                        <td className="text-end small text-muted">offen {formatMenge(p.menge_offen_rest)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>
            )}

            {hatVerfuegbarkeit && (
                <Card className="shadow-sm flex-fill" style={{minWidth: 280}}>
                    <Card.Header className="fw-semibold small">
                        <HeaderWithHelp help="Cosmos-Lagerverfügbarkeit je Kalenderwoche, aus der Ampel-Datei.">
                            Cosmos-Verfügbarkeit
                        </HeaderWithHelp>
                    </Card.Header>
                    <Card.Body className="p-2">
                        <Table size="sm" borderless className="mb-0">
                            <tbody>
                                {verfuegbarkeiten.slice(0, 6).map((v, i) => (
                                    <tr key={i}>
                                        <td className="small text-muted">{formatDatum(v.stand_am)}</td>
                                        <td className="small">{formatCosmosWoche(v.kw_bezeichnung)}</td>
                                        <td className="text-end">{formatMenge(v.menge)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>
            )}

            {hatWarenkorb && (
                <Card className="shadow-sm flex-fill" style={{minWidth: 220}}>
                    <Card.Header className="fw-semibold small">
                        <HeaderWithHelp help="Positionen aus stehengebliebenen B2B-Warenkörben – unverzerrte Nachfrage, die sonst nirgends erhoben wird.">
                            Stehengebliebene B2B-Warenkörbe
                        </HeaderWithHelp>
                    </Card.Header>
                    <Card.Body className="p-2">
                        <div className="fw-semibold fs-5">{formatMenge(warenkoerbe.anzahl)}</div>
                        <div className="small text-muted">{formatMenge(warenkoerbe.menge)} Dosen insgesamt</div>
                    </Card.Body>
                </Card>
            )}
        </div>
    );
}
